import React from "react";
import { Outlet } from "react-router-dom";
import FrontViewLayout from "../layout/FrontViewLayout";

const PublicRoutes: React.FC = () => {
  return (
    <FrontViewLayout>
      <Outlet />
    </FrontViewLayout>
  );
};

export default PublicRoutes;
